import ignite from '../../services';

const ProductActions = {
  PRODUCT_CART_LOAD_STARTED: 'PRODUCT_CART_LOAD_STARTED',
  PRODUCT_CART_LOAD_FAILED: 'PRODUCT_CART_LOAD_FAILED',
  PRODUCT_CART_UPDATE_STARTED: 'PRODUCT_CART_UPDATE_STARTED',
  PRODUCT_CART_UPDATE_COMPLETED: 'PRODUCT_CART_UPDATE_COMPLETED',
  PRODUCT_CART_UPDATE_FAILED: 'PRODUCT_CART_UPDATE_FAILED',
};

const productCartStateKey = 'productCart';
const productCartAnswerKey = 'productsSavedToCart';
const productCartActionKey = 'addToCartClicked';
const productCartKeys = {
  answerKey: productCartAnswerKey,
  actionKey: productCartActionKey,
  stateKey: productCartStateKey,
};
const mergeCustomCartKeys = (customKeys) => {
  return {
    ...productCartKeys,
    ...customKeys,
  };
};

const loadProductCart = (customKeys) => {
  const cartKeys = mergeCustomCartKeys(customKeys);
  return async (dispatch) => {
    try {
      dispatch(loadProductCartStarted());
      const response = await ignite.answerService.getAnswer(cartKeys.answerKey);
      dispatch(
        updateProductCartCompleted(
          new Set(response.value || []),
          cartKeys.stateKey
        )
      );
    } catch (ex) {
      dispatch(loadProductCartFailed(ex));
    }
  };
};

const loadProductCartFailed = (error) => {
  return {
    type: ProductActions.PRODUCT_CART_LOAD_FAILED,
    error,
    loadingProductCart: false,
  };
};

const loadProductCartStarted = () => {
  return {
    type: ProductActions.PRODUCT_CART_LOAD_STARTED,
    loadingProductCart: true,
  };
};

const updateProductCart = (
  productCart,
  productId,
  removeItem = false,
  customKeys
) => {
  const cartKeys = mergeCustomCartKeys(customKeys);
  return async (dispatch) => {
    try {
      const productIdString = productId.toString();

      dispatch(updateProductCartStarted(productIdString));

      const updatedProductSet = new Set(productCart);
      removeItem
        ? updatedProductSet.delete(productIdString)
        : updatedProductSet.add(productIdString);

      const toSend = {
        productId,
        removeItem,
        updatedProductSet,
        cartKeys,
      };

      // noinspection ES6MissingAwait
      updateServerCart(dispatch, toSend);
      dispatch(
        updateProductCartCompleted(updatedProductSet, cartKeys.stateKey)
      );
    } catch (ex) {
      dispatch(updateProductCartFailed(ex));
    }
  };
};

const addAllProducts = (listOfProducts) => {
  return async (dispatch) => {
    try {
      const productIdList = listOfProducts
        .filter((p) => p.id)
        .map((p) => p.id.toString());

      dispatch(updateProductCartStarted(productIdList.toString()));

      const updatedProductSet = new Set(productIdList);

      const toSend = {
        updatedProductSet,
      };

      // noinspection ES6MissingAwait
      updateServerCart(dispatch, toSend);
      dispatch(updateProductCartCompleted(updatedProductSet));
    } catch (ex) {
      dispatch(updateProductCartFailed(ex));
    }
  };
};

const updateProductCartCompleted = (
  productCart,
  productCartKey = productCartKeys.stateKey
) => {
  return {
    type: ProductActions.PRODUCT_CART_UPDATE_COMPLETED,
    productCart,
    productCartKey,
    loadingProductCart: false,
  };
};

const updateProductCartFailed = (error) => {
  return {
    type: ProductActions.PRODUCT_CART_UPDATE_FAILED,
    error,
  };
};

const updateProductCartStarted = (productId) => {
  return {
    type: ProductActions.PRODUCT_CART_UPDATE_STARTED,
    productId,
  };
};

const updateServerCart = async (
  dispatch,
  { productId, removeItem, updatedProductSet, cartKeys = productCartKeys }
) => {
  try {
    const promises = [];
    if (removeItem) {
      promises.push(
        ignite.answerService.removeProductAnswer({
          appkey: cartKeys.actionKey,
          productId,
        })
      );
    } else {
      promises.push(
        ignite.answerService.actionCompleted({
          appkey: cartKeys.actionKey,
          productId,
        })
      );
    }

    if (updatedProductSet) {
      promises.push(
        ignite.answerService.saveAnswer({
          appkey: cartKeys.answerKey,
          value: Array.from(updatedProductSet),
          timestamp: new Date(),
        })
      );
    }

    await Promise.all(promises);
  } catch (ex) {
    dispatch(updateProductCartFailed(ex));
  }
};

export { addAllProducts, loadProductCart, ProductActions, updateProductCart };
